module.exports = __webpack_public_path__ + "img/sub14.134fe540.jpg";